import { IOrders } from '../../types/orders';
import { axiosInstance } from '../axiosInstance';

export const getOrders = async (token: string | null): Promise<IOrders> => {
  const headers: { Authorization?: string } = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await axiosInstance.get(`/view/orders/my-orders`, {
    headers: headers,
  });
  return response.data;
};
